import Icon from '@/components/common/icons/Icon';
import IconBackground from '@/components/common/icons/IconBackground';
import { FlexProps } from '@chakra-ui/react';
import { TransactionEntryCategoryGroupFieldsFragment } from '@common/graphql/generated';
import { getIconColor } from '@common/react/cashflow';

interface CategoryGroupIconProps {
    categoryGroup: Pick<
        TransactionEntryCategoryGroupFieldsFragment,
        'iconName' | 'name'
    >;
    size?: FlexProps['w'];
    withBackground?: boolean;
    color?: string;
}

const CategoryGroupIcon = ({
    categoryGroup,
    size = 'sm',
    withBackground = true,
    color = 'black',
}: CategoryGroupIconProps) => {
    const iconName = categoryGroup.iconName;
    const bgColor = getIconColor(categoryGroup.name);

    if (!withBackground) {
        return <Icon name={iconName} color={color} size={size} />;
    }

    return (
        <IconBackground bg={bgColor} size={size}>
            <Icon name={iconName} color={color} size={size} />
        </IconBackground>
    );
};

export default CategoryGroupIcon;
